import { RSAA } from 'redux-api-middleware';
import { ANALYTICS_ERROR, METHOD_GET } from '../../utils/constants';
import { getPayload } from '../../utils';
import * as analytics from '../../utils/analytics';
import { technicalErrorPage } from '../../store/dataCapture/actions';

export const FETCH_CUSTOMERBYID = 'FETCH_CUSTOMERBYID';
export const FETCH_CUSTOMERBYID_SUCCESS = 'FETCH_CUSTOMERBYID_SUCCESS';
export const FETCH_CUSTOMERBYID_FAILED = 'FETCH_CUSTOMERBYID_FAILED';
export const fetchCustomerById = (customerId, type) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/${customerId}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: FETCH_CUSTOMERBYID,
        meta: {
          isCustomerLoaded: true
        }
      },
      {
        type: `${type}${FETCH_CUSTOMERBYID_SUCCESS}`,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, _state, res) => isNonPersonalCustomer(res.json, customerId)
      },
      {
        type: FETCH_CUSTOMERBYID_FAILED,
        meta: () => {
          analytics.error({
            errorCode: 0,
            errorMessage: ANALYTICS_ERROR.FETCH_CUSTOMERBYID_FAILED
          });
          return { nextAction: technicalErrorPage(), isCustomerLoaded: false };
        }
      }
    ]
  }
});

export const GET_CUSTOMER = 'GET_CUSTOMER';
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAILED = 'GET_CUSTOMER_FAILED';
export const getCustomer = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers`,
    method: METHOD_GET,
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: GET_CUSTOMER,
        meta: {
          loading: true
        }
      },
      {
        type: GET_CUSTOMER_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, _state, res) => ({
          nextAction: fetchCustomerById(
            res.json.customers.filter(cust => cust.relationship === 'OWNER')[0].id,
            ''
          ),
          loading: false
        })
      },
      {
        type: GET_CUSTOMER_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

const isNonPersonalCustomer = (res, id) => {
  if (res.principle_contact) {
    return {
      nextAction: fetchCustomerById(res.principle_contact, ''),
      isCustomerLoaded: false
    };
  }
  return {
    isCustomerLoaded: false,
    id: id
  };
};
